export function fillSelectedPerson(person, $scope) {
	let $hiddenPersonId = $scope.querySelector('.person-attributes-id'),
		objectName = $scope.dataset.objectName;

	if (!$hiddenPersonId) {
		$scope.insertAdjacentHTML('beforeEnd', `<input type="hidden" name="${objectName}[id]" class="person-attributes-id">`);
		$hiddenPersonId = $scope.querySelector('.person-attributes-id');
	}

	$hiddenPersonId.value = person.id;
	fillPersonObject(person, ['name', 'cpf', 'rg'], objectName, $scope);
	fillPersonObject((person.user || {}), ['email', 'accept'], `${objectName}[user_attributes]`, $scope);

	let $anchor = $scope.querySelector('.manageable-addresses a.add-row');
	$anchor.dataset.hideModal = true;

	fillPersonAry(person, 'contacts', '.new-contact', $scope);
	fillPersonAry(person, 'addresses', '.manageable-addresses a.add-row', $scope)
		.then(() => {
			$scope.querySelectorAll('.person-addresses.entries-cards .entry-card.address-card').forEach(($card) => {
				$card.classList.remove('unsaved');
				$card.querySelector('.not-persisted-address').remove();
				delete $anchor.dataset.hideModal;
				setTimeout(() => $card.dispatchEvent(new Event('printOutput')), 100);
			});
		});
}

function fillPersonObject(object, fields, objectName, $scope) {
	fields.forEach((field) => {
		let inputType = typeof object[field] === 'boolean' ? '[type="checkbox"]' : '',
			$input = $scope.querySelector(`[name="${objectName}[${field}]"]${inputType}`),
			checkbox = $input.getAttribute('type') === 'checkbox';

		checkbox ? ($input.checked = false) : ($input.value = '');

		if (!object[field])
			return;

		checkbox ? ($input.checked = object[field]) : ($input.value = object[field]);
	});
}

function fillPersonAry(person, aryAttribute, anchorSelector, $scope) {
	return new Promise((resolve, _) => {
		let hiddenAryAttributes = `_${aryAttribute}`,
			$anchorNewAry = $scope.querySelector(anchorSelector);
		$anchorNewAry.addEventListener('add-row:appended', (ev) => {
			fillObject(person, hiddenAryAttributes, ev.detail.row, resolve);
		});

		$scope.querySelector($anchorNewAry.dataset.at).innerHTML = '';

		person[hiddenAryAttributes] = person[aryAttribute] || [];
		(person[aryAttribute] || []).forEach((() => setTimeout(() => $anchorNewAry.click(), 10)));
	});
}

function fillObject(person, aryField, $row, resolve) {
	let object = person[aryField].shift();

	if (!object)
		return resolve();

	Object.keys(object).forEach((field) => {
		let $input = $row.querySelector(`[name*="[${field}]"]`);
		appendObjectIdToRow($input, $row, object.id);

		if (!!$input)
			$input.value = object[field];
	});

	if (person[aryField].length == 0)
		return resolve();
}

function appendObjectIdToRow($input, $row, id) {
	if (!!$row.querySelector('[name*="id"') || !$input)
		return;

	let inputName = $input.name.replaceAll(/(.*)\]\[(.*)?\]$/ig, '$1][id]');
	$row.insertAdjacentHTML('beforeEnd', `<input type="hidden" name="${inputName}" value="${id}">`);
}